import { storeToRefs } from 'pinia';
import { useBusinessHoursStore } from '@/modules/settings/stores/businessHours';
import type { IBhs, IIBhs } from '@/modules/settings/interfaces/BusinessHours';
import { weekdaysFormat } from '@/modules/settings/utils/parser/bhs';

const useCompanyBusinessHours = () => {
    const businessHoursStore = useBusinessHoursStore();
    const { businessHours } = storeToRefs(businessHoursStore);

    const getCompanyBusinessHours = async (): Promise<IBhs> => {
        if (!businessHours.value.businessHours.length && businessHours.value.timezone === '') {
            const data = {
                timezone: 'America/New York',
                businessHours: [
                    {
                        id: 'Monday',
                        name: 'M',
                        status: true,
                        start_time: '09:00',
                        end_time: '17:00'
                    },
                    {
                        id: 'Tuesday',
                        name: 'T',
                        status: true,
                        start_time: '09:00',
                        end_time: '17:00'
                    },
                    {
                        id: 'Wednesday',
                        name: 'W',
                        status: true,
                        start_time: '09:00',
                        end_time: '17:00'
                    },
                    {
                        id: 'Thursday',
                        name: 'T',
                        status: true,
                        start_time: '09:00',
                        end_time: '17:00'
                    },
                    {
                        id: 'Friday',
                        name: 'F',
                        status: true,
                        start_time: '09:00',
                        end_time: '17:00'
                    }
                ]
            };
            businessHoursStore.setBusinessHours(data);
            return data;
        } else {
            businessHoursStore.setBusinessHours(businessHours.value);
            return businessHours.value;
        }
    };

    const createCompanyBusinessHours = async (businessHours: IIBhs): Promise<void> => {
        businessHoursStore.setBusinessHours(weekdaysFormat(businessHours));
    };

    const deleteCompanyBusinessHours = async (): Promise<void> => {
        businessHoursStore.setBusinessHours({
            timezone: 'UTC',
            businessHours: []
        });
    };

    return {
        // properties
        businessHours,

        // Method
        getCompanyBusinessHours,
        createCompanyBusinessHours,
        deleteCompanyBusinessHours
    };
};

export default useCompanyBusinessHours;
